import React, { Suspense } from 'react';
import { Loader2 } from 'lucide-react';
import ModuleErrorBoundary from '@/soluqr/core/ModuleErrorBoundary';
import { importWithChunkRetry } from '@/routes/lazyPage';

function PageFallback() {
  return (
    <div className="flex h-64 items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
    </div>
  );
}

/** Lazy-load de página del panel con error boundary por módulo. */
export function lazyModulePage(moduleKey, factory) {
  const C = React.lazy(() => importWithChunkRetry(factory));
  return (
    <ModuleErrorBoundary moduleKey={moduleKey}>
      <Suspense fallback={<PageFallback />}>
        <C />
      </Suspense>
    </ModuleErrorBoundary>
  );
}
